var _rect, _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgTotalracks(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 23,
    height: 23,
    viewBox: "0 0 23 23",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 0.608521,
    y: 0.616211,
    width: 21.6031,
    height: 21.6031,
    rx: 10.8016,
    fill: "#273CF7",
    fillOpacity: 0.2
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M9.99237 17.0887H12.8278V5.74707H9.99237V17.0887ZM5.73926 17.0887H8.57467V11.4179H5.73926V17.0887ZM14.2455 9.29133V17.0887H17.0809V9.29133H14.2455Z",
    fill: "#273CF7"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgTotalracks);
export default __webpack_public_path__ + "static/media/totalracks.acfc67551a87a80b158145735c72a10c.svg";
export { ForwardRef as ReactComponent };